var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.00396V5.00396C3.99904 4.0297 4.35368 3.08857 4.99737 2.35724C5.64107 1.6259 6.52954 1.15463 7.49605 1.03188C8.46255 0.909137 9.44062 1.14335 10.2467 1.69057C11.0528 2.23779 11.6314 3.06039 11.874 4.00396M8 13.004C8.26522 13.004 8.51957 12.8986 8.70711 12.7111C8.89464 12.5235 9 12.2692 9 12.004C9 11.7387 8.89464 11.4844 8.70711 11.2969C8.51957 11.1093 8.26522 11.004 8 11.004C7.73478 11.004 7.48043 11.1093 7.29289 11.2969C7.10536 11.4844 7 11.7387 7 12.004C7 12.2692 7.10536 12.5235 7.29289 12.7111C7.48043 12.8986 7.73478 13.004 8 13.004ZM8 13.004V16.004M2.6 8.00396H13.4C14.28 8.00396 15 8.72396 15 9.60396V16.604C15 17.924 13.92 19.004 12.6 19.004H3.4C2.08 19.004 1 17.924 1 16.604V9.60396C1 8.72396 1.72 8.00396 2.6 8.00396Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIcon);
export default __webpack_public_path__ + "static/media/UnlockIcon.c6dcb2e07c8a2429abfe637cd93edd18.svg";
export { ForwardRef as ReactComponent };